// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hZoDn7iTKZfd1KHhJhps9g\\=\\={background-color:var(--codebox);padding:1rem;border-radius:1rem}.RsgU1tBSXV3fXPJjKuyy9A\\=\\={background-color:unset !important}", "",{"version":3,"sources":["webpack://./src/Styles/codebox.module.scss"],"names":[],"mappings":"AAAA,4BACE,+BAAA,CACA,YAAA,CACA,kBAAA,CAGF,4BACE,iCAAA","sourcesContent":[".codebox {\n  background-color: var(--codebox);\n  padding: 1rem;\n  border-radius: 1rem;\n}\n\n.highlighter {\n  background-color: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codebox": "hZoDn7iTKZfd1KHhJhps9g==",
	"highlighter": "RsgU1tBSXV3fXPJjKuyy9A=="
};
export default ___CSS_LOADER_EXPORT___;
